import { useMutation, gql } from "@apollo/client"
import { ADMINABLE_USERS_FIELDS } from "./useQueryAdminableUsers"

const UPDATE_USER_MUTATION = gql`
  ${ADMINABLE_USERS_FIELDS}
  mutation UpdateUser(
    $id: ID!
    $firstName: String
    $lastName: String
    $avatar: String
    $groups: [ID!]
    $locations: [ID!]
    $roles: [ID!]
    $status: AdminableUserStatus
  ) {
    updateUser(
      id: $id
      firstName: $firstName
      lastName: $lastName
      avatar: $avatar
      groups: $groups
      locations: $locations
      roles: $roles
      status: $status
    ) {
      ...AdminableUsersFields
    }
  }
`

const useMutationUpdateUser = () => useMutation(UPDATE_USER_MUTATION)

export { useMutationUpdateUser }
